export default function (error, alert) {
  if (error.response.status === 422) {
    alert(error.response.data.message)
  }
}
